module.exports = __webpack_public_path__ + "static/img/top5crimes.f580f3c9.png";